module.exports = __webpack_public_path__ + "media/newstyle/images/a4-28b01b69cd43dfcd3c8a7df8ced0c017.svg";